<template>
    <div class="photo-lower-bar-button-group">
        <div class="projects-lite-lower-bar-button" v-on:click="showModal('modal-request-custom-design')">
            <SVGStepsProjects id="svg-send-photo" class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Отправить своё фото на визуализацию</span>
        </div>
    </div>
</template>

<script>
    import SVGStepsProjects from "../../../SVG/SVGStepsProjects";
    import {modalMethods} from "../../../common";

    export default {
        name: "LeftLowerBarLiteSendPhoto",
        mixins: [modalMethods],
        components: {SVGStepsProjects}
    }
</script>

<style scoped>
    #svg-send-photo {
        width: 25px;
        height: 25px;
    }
</style>
